import * as React from 'react'
import { parseImageUrl } from '../../drupal/rendering/image_utils.mod'
import { ParsedImageFileWithTargetItem } from '../../drupal/types_and_parser/types'
import { Department } from '../vacancies/utils'

type HeroProps = {
  vacancyImage?: VacancyImage
  image?: ParsedImageFileWithTargetItem
  hasCMSImg: boolean
  hasVacancyImg: boolean
  hasNoBranding?: boolean
}

class HeroVisual extends React.Component<HeroProps, never> {
  render(): React.ReactNode {
    const { hasCMSImg, hasVacancyImg, image, vacancyImage, hasNoBranding } = this.props
    return (
      !hasNoBranding && (
        <div className="pageheader__visual">
          {hasCMSImg && (
            <>
              <div className="pageheader__image-container">
                <img
                  className="pageheader__image"
                  alt={image?.alt}
                  width="850"
                  height="850"
                  src={`${parseImageUrl(image?.image?.style_urls['425w'])}`}
                  srcSet={`${parseImageUrl(image?.image?.style_urls['425w'])} 425w, ${parseImageUrl(
                    image?.image?.style_urls['850w']
                  )} 850w, ${parseImageUrl(image?.image?.style_urls['1225w'])} 1225w`}
                  sizes="(min-width: 1200px) 800px, 500px"
                />
              </div>
            </>
          )}
          {hasVacancyImg && (
            <>
              <div className="pageheader__image-container">
                <img
                  className="pageheader__image lazyload"
                  alt={vacancyImage}
                  width="850"
                  height="850"
                  src={`/images/vacancies/${vacancyImage}-s.jpg`}
                  data-srcset={`/images/vacancies/${vacancyImage}-s.jpg 600w, /images/vacancies/${vacancyImage}-l.jpg 1225w`}
                  sizes="(min-width: 1200px) 800px, 500px"
                />
              </div>
            </>
          )}
        </div>
      )
    )
  }
}

export default HeroVisual

type VacancyImage =
  | 'administration'
  | 'engineering'
  | 'finance-it'
  | 'health-safety'
  | 'hr'
  | 'manufacturing'
  | 'other'
  | 'purchasing'
  | 'sales-marketing'
  | 'supply-chain'
  | 'warehouse'

export const getVacancyImage = (department: Department): VacancyImage => {
  switch (department) {
    case 'Executive Management':
    case 'Operations': {
      return 'administration'
    }
    case 'Supply Chain & Logistics': {
      return 'supply-chain'
    }
    case 'Customer Service':
    case 'Research & Development (R&D)':
    case 'Legal & Compliance':
    case 'Other':
    case 'Corporate Communications':
    case 'Administrative Support': {
      return 'other'
    }
    case 'Manufacturing': {
      return 'manufacturing'
    }
    case 'Engineering':
    case 'Maintenance': {
      return 'engineering'
    }
    case 'Quality & Food Safety':
    case 'Health, Safety & Environment (HSE)': {
      return 'health-safety'
    }
    case 'Procurement & Purchasing': {
      return 'purchasing'
    }
    case 'Human Resources (HR)': {
      return 'hr'
    }
    case 'Finance':
    case 'Information Technology (IT)': {
      return 'finance-it'
    }
    case 'Sales & Marketing': {
      return 'sales-marketing'
    }
  }
}
